import gql from 'graphql-tag'

export default (tableName, { id, active }) => {
	return {
		mutation: gql`mutation updateSingleContactCategoryActive(
			$id: bigint!,
			$active: Boolean!
		) {
			update_${tableName}_by_pk(pk_columns: {id: $id}, _set: {active: $active}) {
				id
			}
		}`,
		variables: {
			id,
			active
		}
	}
}
